import { useLazyQuery, useMutation } from "@apollo/client";
import {
  IScratchPayEligibilityResponse,
  IScratchPayPurchaseInput,
  IScratchPayPurchaseResponse,
  IScratchPayStatusResponse,
} from "./scratchpay.interface";
import { SCRATCHPAY_ELIGIBILITY, SCRATCHPAY_PURCHASE_STATUS } from "./scratchpay.query";
import { SCRATCHPAY_PURCHASE } from "./scratchpay.mutation";

export const useScratchPayEligibility = () => {
  const [checkEligibility, { data, loading, error, refetch }] = useLazyQuery<{
    scratchpayEligibility: IScratchPayEligibilityResponse;
  }>(SCRATCHPAY_ELIGIBILITY, {
    fetchPolicy: "network-only",
  });

  return {
    checkEligibility,
    eligible: data?.scratchpayEligibility?.eligible,
    loading,
    error,
    refetch,
  };
};

export const useScratchPayPurchase = () => {
  const [initiatePurchase, { data, loading, error, reset }] = useMutation<
    { scratchpayPurchase: IScratchPayPurchaseResponse },
    IScratchPayPurchaseInput
  >(SCRATCHPAY_PURCHASE);

  return {
    initiatePurchase,
    purchaseData: data?.scratchpayPurchase,
    loading,
    error,
    reset,
  };
};

export const useScratchPayPurchaseStatus = () => {
  const [checkStatus, { data, loading, error, stopPolling, startPolling }] = useLazyQuery<{
    scratchpayPurchaseStatus: IScratchPayStatusResponse;
  }>(SCRATCHPAY_PURCHASE_STATUS, {
    fetchPolicy: "network-only",
    pollInterval: 3000,
  });

  return {
    checkStatus,
    statusData: data?.scratchpayPurchaseStatus,
    loading,
    error,
    stopPolling,
    startPolling,
  };
};

